const initialState: MBChannelCreateState = {
  selectedUsers: [],
  workspaceSectionId: undefined,
  accessLevel: undefined,
  includeCardData: false,
};

export function channelCreateReducer(
  state: MBChannelCreateState = initialState,
  action: ChannelCreateAction,
): MBChannelCreateState {
  switch (action.type) {
    case 'CHANNEL:CREATE:ADD_SELECTED_USER': {
      return {
        ...state,
        selectedUsers: [...state.selectedUsers, action.value.user],
      };
    }
    case 'CHANNEL:CREATE:REMOVE_SELECTED_USER': {
      return {
        ...state,
        selectedUsers: state.selectedUsers.filter(u => u.id !== action.value.user.id),
      };
    }
    case 'CHANNEL:CREATE:SET_WORKSPACE_LIST_SECTION':
      return { ...state, workspaceSectionId: action.value.id };
    case 'CHANNEL:CREATE:RESET_SELECTED_USERS':
      return { ...state, selectedUsers: action.value.users };
    case 'CHANNEL:CREATE:SET_ACCESS_LEVEL':
      return { ...state, accessLevel: action.value.accessLevel };
    case 'CHANNEL:CREATE:SET_INCLUDE_CARD_DATA':
      return { ...state, includeCardData: action.value.includeCardData };
    default:
      return state;
  }
}
